import apiClient from './client';

export const authApi = {
  login: (email, password, { tenantSlug } = {}) =>
    apiClient.post('/auth/login', { email, password }, {
      headers: tenantSlug ? { 'X-Tenant-Slug': tenantSlug } : {},
    }),

  logout: (refreshToken) =>
    apiClient.post('/auth/logout', { refreshToken }),

  refresh: (refreshToken) =>
    apiClient.post('/auth/refresh', { refreshToken }),

  getMe: () => apiClient.get('/auth/me'),

  updateProfile: (data) => apiClient.patch('/auth/me', data),

  changePassword: (data) => apiClient.patch('/auth/me/password', data),

  forgotPassword: (email) =>
    apiClient.post('/auth/forgot-password', { email }),

  resetPassword: (token, password, confirmPassword) =>
    apiClient.post('/auth/reset-password', { token, password, confirmPassword }),
};
